module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "chapter03"
    }
  }, [_c('a', {
    attrs: {
      "id": "page114"
    }
  }), _c('a', {
    attrs: {
      "id": "page115"
    }
  }), _c('div', {
    staticClass: "chapterHead"
  }, [_c('a', {
    attrs: {
      "id": "page115"
    }
  }), _c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page115"
    }
  }, [_c('span', {
    staticClass: "xrefInternal"
  })]), _c('a', {
    attrs: {
      "href": "#/text/9780062018465_Contents#chapter_03"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3.")])])]), _vm._v(" "), _c('h2', {
    staticClass: "chapterTitle",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062018465_Contents#chapter_03"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Winckelmann, Wolf, and Lessing: The Third Greek Revival and the Origins of Modern Scholarship")])])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("T")])]), _vm._v("he Italian Renaissance was a German idea. The man who formulated it most clearly, Jacob Burckhardt (1818–97), author of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Die Kultur der Renaissance in Italien")]), _vm._v(" ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Civilisation of the Renaissance in Italy")]), _vm._v("; 1878), was born in Basel, Switzerland, in 1818, but studied at the University of Berlin, where he attended the seminars of the most famous historian of the time, Leopold von Ranke. Burckhardt returned to Basel in 1843 and began to lecture there at the university, as well as edit a newspaper, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Basler Zeitung")]), _vm._v(". Growing disillusioned with journalism, he abandoned it for full-time historical research, a move that led to his first major book, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Die Zeit Konstantins des Grossen")]), _vm._v(" ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Age of Constantine the Great")]), _vm._v("; 1853), soon followed by a historical guide to the art treasures of Italy, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Der Cicerone")]), _vm._v(" ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Cicerone")]), _vm._v("; 1855). These two works were so well received that they earned him a chair—in architecture and art history—at Zurich Polytechnic when it opened in 1855. Three years later he returned to the university at Basel and remained there for the rest of his life, spurning the invitation to become Ranke’s successor at Berlin. It was from Basel that, in 1860, he published his most famous book."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n219",
      "id": "n219",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Before Burckhardt, other writers and historians had introduced the "), _c('a', {
    attrs: {
      "id": "page116"
    }
  }, [_vm._v("phenomenon of the Renaissance. Petrarch (1304–74) was the first to recognize, on paper at least, the idea of the “Dark Ages,” that the thousand years—more or less—before he lived had been a period of decline, and that ancient history, poetry, and philosophy were “radiant examples” of a civilization that was the highest form of life before Christ appeared. Voltaire, Saverio Bettinelli, the French historian Jules Michelet, and Georg Voigt, professor of history at Munich, in his 1859 book "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Die Wiederbelebung des classischen Altertums: oder, das erste Jahrhundert des Humanismus")]), _vm._v(" (The Revival of Classical Antiquity, or the First Century of Humanism), had all drawn attention to Renaissance Italy. Burckhardt’s ideas did not come out of nowhere.")])]), _c('a', {
    attrs: {
      "id": "page116"
    }
  }), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page116"
    }
  }, [_vm._v("Nevertheless, his understanding of the Renaissance was much more coherent and complete than that of any of his predecessors."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n220",
      "id": "n220",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")]), _vm._v(" It was Burckhardt who confirmed that the Italian Renaissance was far more than the rediscovery of antiquity: it had seen the development of the individual, it was then that the lineaments of modernity first appeared. Burckhardt maintained that society was now a self-conscious—and therefore a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("secular")]), _vm._v("—entity as it had never been before.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("As Peter Burke, the Cambridge historian of ideas, has emphasized, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Civilisation of the Renaissance in Italy")]), _vm._v(" did not lack for critics. After 150 years of increasingly specialized research, he said, “it is easy to point out exaggerations, rash generalisations and other weaknesses.” But though Burckhardt’s view of the Renaissance may be flawed, Burke agreed that “it is also difficult to replace.” Perhaps the single most important revision of Burckhardt’s argument is that of Charles Homer Haskins, professor of history at Harvard in the early decades of the twentieth century. Haskins’s contention was that the essentially Platonic revival in Italy in the fourteenth and fifteenth centuries, which gave rise to the Italian Renaissance, was in fact, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("second")]), _vm._v(" such classical revival in the West. The first, associated with the rediscovery not of Plato but of Aristotle, took place in the twelfth century and was marked by, for example, the new science of law and a unified legal system, which promoted the idea of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("shared")]), _vm._v(" knowledge that could be argued over, the wider use of Latin, the development of universities, and the growth of organized skepticism in scholarship. With the philosophy of Albertus Magnus and Thomas Aquinas, which envisaged a secular world, came a unification of thought in theology and the "), _c('a', {
    attrs: {
      "id": "page117"
    }
  }, [_vm._v("liberal arts, giving rise to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Summae")]), _vm._v(", encyclopedic treatises aimed at synthesizing all knowledge, changes in worship, which promoted a rise in self-expression and individuality, and, perhaps most significant of all, the rise of the experimental method, giving birth to science as we know it. Among historians, then, if not yet among the general public, there were "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("two")]), _vm._v(" renaissances, not one, with the first rather more important than the second.")])]), _c('a', {
    attrs: {
      "id": "page117"
    }
  }), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page117"
    }
  }, [_vm._v("Against this background, a closer reading of Burckhardt’s book reveals some interesting further observations."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n221",
      "id": "n221",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")]), _vm._v(" The Renaissance in Italy, he said, was characterized by the following elements: the revival of antiquity, the rediscovery of the texts of Plato and the civilizations of ancient Greece and Rome, before the years of Christian fundamentalism, “as the source and basis of culture…as the object and ideal of existence.” The recovery of the classics, Burckhardt said, led to the growth of textual criticism and the more advanced study of languages—there was a revival of new learning in which philology played a central role. It was in the High Renaissance (1513) that Pope Leo X reorganized Rome’s university, La Sapienza. The Florentines, Burckhardt said, “made antiquarian interests one of the chief objects of their lives,” accompanied by advances in the sphere of science. The treatise was revived, as was history writing, two forms of literature and inquiry that were felt as new. In philosophy, the Florentine Platonists had a massive influence on thought and on literature, aesthetics in particular. In poetry, ancient Greece and Rome were again the model, stimulating imitation but also more imaginative works by poets who were, in addition, often scholars. In natural history there were advances in botany (the first botanical gardens), and in zoology (the first collections of foreign animals). In art it was the era of “many-sided men,” individuals such as Leon Battista Alberti and Leonardo da Vinci, giants who shone in many different fields.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("In other sections of his book, Burckhardt said that attitudes to and beliefs about war changed in the Italian Renaissance. In a section on “War as a work of art,” he argued that “War assumed the character of a product of reflection.” And from Dante and Petrarch onward, there was in Italy a ferment of patriotism and nationalism. “Dante and Petrarch, in their day, proclaimed loudly a common Italy, the object of the highest efforts of all her children.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Finally, in music Burckhardt identified a characteristic of the Italian "), _c('a', {
    attrs: {
      "id": "page118"
    }
  }, [_vm._v("Renaissance as “the specialisation of the orchestra, the search for new instruments and modes of sound, and, in close connection with this tendency, the formation of a class of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("virtuosi")]), _vm._v(", who devoted their whole attention to particular instruments or particular branches of music.” This all amounted to a celebration of humanism—the glories that humankind is capable of, without specific and continual reference to God.")])]), _c('a', {
    attrs: {
      "id": "page118"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("There is a saying in the military that the darkness is deepest under the light and it is the opening argument of this chapter that such is the case here. That Burckhardt, in shining the light of his intellect and his historical imagination on fourteenth- and fifteenth-century Italy, cast a shadow over the culture of which he himself was a part. It will be argued here that, beginning in the middle of the eighteenth century, there was a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("third")]), _vm._v(" classical revival in Europe, that it resulted in a flourishing—a renaissance—of the arts and sciences, that it saw great reflection and innovation in military affairs, and that it stimulated an unparalleled philosophical revival. This promoted a surge in new aesthetic theory (already introduced in the previous chapter), including advances by poets—such as Goethe and Schiller—who were also scholars and many-sided men. It was accompanied by a great surge in patriotism and a demand for unification—this time of Germany. Other parallels may be found in music and in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Humanität")]), _vm._v(", the German form of humanism. The greatest names in musical history—from Mozart to Arnold Schoenberg—were all German. The links between "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wissenschaft")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bildung")]), _vm._v(", and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Innerlichkeit")]), _vm._v(", formulated most forcefully in the brand-new University of Berlin (founded in 1810), were to be the clearest embodiment of the German idea of humanism (all of which are discussed below).")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Just as, in the Italian Renaissance, Pope Leo X reorganized La Sapienza in Rome, so in Germany a completely new idea of learning, which fundamentally shaped the modern world, was evolved. There were new forms of literature and new forms of inquiry, in which philology once again formed the core. Archaeology—the modern equivalent of antiquarianism—underwent its heroic age. This third renaissance was without question primarily German.")])]), _c('a', {
    attrs: {
      "id": "page119"
    }
  }, [_c('p', {
    staticClass: "chapterHeadA",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("HE")]), _vm._v(" F"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ATHER OF")]), _vm._v(" C"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("LASSICAL")]), _vm._v(" A"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("RCHAEOLOGY AND THE")]), _vm._v(" F"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("OUNDER OF")]), _vm._v(" A"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("RT")]), _vm._v(" H"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ISTORY")])])]), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page119"
    }
  }, [_vm._v("If the Aristotelian renaissance was sparked by the rediscovery of Arabic translations of his masterpieces in Toledo, Lisbon, Segovia, and Cordoba, after the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Reconquista")]), _vm._v(" of the Iberian Peninsula by the Christians, and if the Platonic revival owed a great deal to scholars such as Giovanni Aurispa, who brought back from just one visit to Constantinople on the eve of the Turkish conquest no fewer than 238 Greek manuscripts, the same honor in the eighteenth century goes to Karl Weber (1767–1832) and Johann Joachim Winckelmann (1717–68). Winckelmann is the better-known figure but recent scholarship credits Weber, a military engineer in the Swiss guard, with being the man whose great efficiency and devotion to detail ensured that the excavations south of Naples—at Herculaneum, Pompeii, and Stabiae, in particular the Villa dei Papiri—were actually carried out in a workmanlike way, and thus enabled the groundwork to be completed on which Winckelmann would base his groundbreaking survey of classical art."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n222",
      "id": "n222",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Born in Stendal in Prussia in 1717, the son of a cobbler, Winckelmann grew up in a house with just one room, which was also his father’s workshop. He pestered his parents to give him an education that was beyond their means and, in one way and another, found his way to Berlin, to study under Christian Tobias Damm, “one of the few men then alive in Germany who exalted Greek above Latin at a time when the study of the Greek language was almost entirely neglected.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n223",
      "id": "n223",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" After Berlin, Winckelmann transferred to the universities of Halle and Jena, where he studied medicine, philosophy, and mathematics, supporting himself as a tutor."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n224",
      "id": "n224",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" He would read Greek till midnight, sleep in an old coat in an armchair until four in the morning, when he would resume reading."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n225",
      "id": "n225",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" In the summer months he slept on a bench with a block of wood tied to his foot which fell down at the slightest movement and wakened him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Winckelmann’s interest in art and antiquities was nurtured after he obtained employment as a research assistant (as we would say) to Count Bünau near Dresden (which boasted more art than did any other city in Germany), but the crucial episode was his meeting with the papal "), _c('a', {
    attrs: {
      "id": "page120"
    }
  }, [_vm._v("nuncio in the city, who offered Winckelmann the opportunity to work in Rome—provided he convert to Catholicism."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n226",
      "id": "n226",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Winckelmann arrived in Rome in 1755. For him and others like him, the statues in Rome were invariably regarded as the most important masterpieces of ancient art."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n227",
      "id": "n227",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" He began in the service of Cardinal Alessandro Albani, who had a villa just outside Rome, where he was made librarian and given charge of the antiquities collection. But the fame he would soon acquire had much more to do with several visits he made to Herculaneum and Pompeii, just then attracting widespread interest.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("They had been “rediscovered” in 1738 when the Spanish military engineer Rocque Joachin Alcubierre was ordered to survey a site and prepare plans for a new summer palace for King Charles VII of Bourbon at Portici, on the Italian coast south of Naples. This was not entirely accidental. Local residents in the nearby town of Resina had long obtained their water by drilling artesian wells and were fully aware that there were ruins underground—chance finds of antiquities had been occurring since Renaissance times. Alcubierre was instructed by the king to “make some grottoes and see what might be discovered.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n228",
      "id": "n228",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Excavations began in October 1738. In some places the volcanic lava was fifty feet thick and it was not until November that a marble "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hercules")]), _vm._v(" was recovered, and it was the middle of January the following year before an inscription—of L. Annius Mammianus Rufus—revealed that a structure originally believed to be a temple was in fact a theater."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n229",
      "id": "n229",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" This reorientation was important, for a theater—unlike a temple—implied that the building was part of a city. It was Rufus’s name for his theater, Theatrum Herculanense, that confirmed the city as Herculaneum. Excavations at nearby Pompeii began in April 1748.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Winckelmann visited Herculaneum and Pompeii twice, and although his excursions were not popular (the excavators were worried that he would steal their thunder), Winckelmann managed to familiarize himself with the discoveries at the Vesuvian cities, with the internal politics of the excavations, and with the contents of the more important finds at the Villa dei Papiri."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n230",
      "id": "n230",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("It was this series of coincidences, rivalries, and sensational discoveries that provided the background to Winckelmann’s publications that would "), _c('a', {
    attrs: {
      "id": "page121"
    }
  }, [_vm._v("prove so important in stimulating the third Greek revival. These consisted of, first, a series of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sendschreiben")]), _vm._v(", or Open Letters, on the discoveries south of Naples; second, Winckelmann’s main work, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Die Geschichte der Kunst des Altertums")]), _vm._v(" ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The History of the Art of Antiquity")]), _vm._v("; 1764); and third, his "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Monumenti antichi inediti")]), _vm._v(" (Unpublished Relics of Antiquity; 1767). As E. M. Butler, puts it, however, “His "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("magnum opus")]), _vm._v(" is in a class apart, for it completely revolutionized the study of art by treating it organically (Winckelmann was the first to do so) as part of the growth of the human race.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n231",
      "id": "n231",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The History of the Art of Antiquity")]), _vm._v(" is divided into two parts. The first is more conceptual, examining the phenomenon of art itself, its very “essence.” Here, in a broad way, Winckelmann compares the art of different periods and peoples. The second part concentrates particularly on the tradition of Greek art, from early times to its decline with the fall of the Roman Empire, and it was Winckelmann’s beautifully written description of this “trajectory” that had such impressive consequences.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("For his argument, Winckelmann relied on the new statuary being excavated south of Naples though he did his best to amalgamate the discoveries there with the writings of Pliny (Pliny’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Natural History")]), _vm._v(", completed in "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("A.D.")]), _vm._v(" 79, is as much an art history of the classical world as a geography). Pliny argued that most of the famous ancient Greek artists produced their masterpieces in the fifth and fourth centuries "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("B.C.")]), _vm._v(" For him, Greek sculpture achieved classic perfection while Phidias was at the peak of his powers, in the mid-fifth century "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("B.C.")]), _vm._v(", but Pliny also insisted, famously, that after the age of Alexander the Great “cessavit deindre ars” (art thereafter was inactive or ceased). Building on what he had seen south of Naples, Winckelmann refined Pliny’s argument, discerning, he said, a “high” austere “early classical” style, associated with artists such as Phidias, and a “beautiful or graceful late classical style associated with subsequent masters such as Praxitiles and Lysippus.” His identification of an evolution, from one style to the other, a refinement from the “hard stylized” forms of the archaic, to the “austere, early classic,” with the graceful “late classic” leading to overelaboration, and then to decline, suggested a pleasing, organic, coherent system, the sheer symmetry of which many found irresistible."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n232",
      "id": "n232",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("It didn’t matter that Winckelmann used the evidence of statues that "), _c('a', {
    attrs: {
      "id": "page122"
    }
  }, [_vm._v("have subsequently come to be recognized as inferior Roman copies of earlier Greek masterpieces. What mattered is that, whereas classical scholars had previously speculated in a vague way about the rise and fall of art in antiquity, Winckelmann identified instead a sequence of clearly defined phases. More than this, Winckelmann also argued that the classical period of art in antiquity coincided with what other historians called the golden age of Greek culture, that period between the close of the Persian Wars in the early fifth century "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("B.C.")]), _vm._v(" and the Macedonian invasion of Greece toward the end of the fourth century "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("B.C")]), _vm._v(". Whereas previously, ancient monuments had invariably been classified according to their iconography, or subject matter, following Winckelmann they were categorized stylistically, with reference to their period of origin. This transformed connoisseurship.")])]), _c('a', {
    attrs: {
      "id": "page122"
    }
  }), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page122"
    }
  }, [_vm._v("Winckelmann’s other innovation was his fusion of history and aesthetics, “in which the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("essence")]), _vm._v(" of a tradition would be located historically at a single "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("privileged")]), _vm._v(" moment when it supposedly achieved perfection.” In linking artistic “perfection” with a particular historical period, he transformed the history of art, making it important in a sense that it had not been before. That gave it a contemporary relevance, too, suggesting that there was little prospect of any real revival in Winckelmann’s own time."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n233",
      "id": "n233",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Especially famous was his description of the Laocoön group in the Vatican. “The universal and predominant characteristic of the Greek masterpieces is "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("a noble simplicity and tranquil grandeur")]), _vm._v(", both in posture and expression. Just as the depths of the sea remain for ever calm, however much the surface may rage, so does the expression of the Greek figures, however strong their passions, reveal a great and dignified soul.”’ (Italics added.)"), _c('span', {
    staticClass: "footnoteRef"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Footnote_8",
      "id": "footnote8",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("*")])])]), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n234",
      "id": "n234",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" This analysis had repercussions far wider than such words—however apposite—could have now. The Laocoön’s importance lay in the fact that, having been specifically referred to by Pliny, when it was rediscovered in an excavation in Rome in 1506, it provided a direct link with the past. Now in the Vatican, this classic marble sculpture shows the Trojan priest Laocoön and his sons being attacked by a fierce sea serpent. Whatever our reactions today to what many people think is an overwrought monument, "), _c('a', {
    attrs: {
      "id": "page123"
    }
  }, [_vm._v("at the time Winckelmann’s arguments had “the force of revelation.” His arguments were considered so original, and so incisive, that he became a national figure almost overnight: “Except for Frederick the Great of Prussia, he was the most renowned German between Leibniz and Goethe.” The Laocoön itself became a cult object, discussed everywhere."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n235",
      "id": "n235",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Among the implications of Winckelmann’s argument, picked up on by Herder, Goethe, Friedrich and August Wilhelm Schlegel, and Hegel, was the notion that there is a historical divide separating ancient from modern culture, where modern culture is in fact “the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("antithesis")]), _vm._v(" of the integrated wholeness of ancient Greek culture, of its naïve simplicity and centredness, and of its unmediated relation to itself and nature.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n236",
      "id": "n236",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" Whether one agrees or not, Winckelmann’s achievement was that he took beauty seriously, as the center of existence, not as embellishment. Above all, he suggested that if we allow the Greek ideal to influence and permeate our lives, we can hope to reproduce the conditions necessary for great art; we can attain, in other words, a form of perfection."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n237",
      "id": "n237",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("This was all very heady. As George Santayana was to tease: “How pure the blind eyes of statues, how chaste the white folds of the marble drapes.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n238",
      "id": "n238",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" But beyond Winckelmann’s inimitable style, beyond his idea of the ennobling power of beauty, it is possible to see an even deeper significance in his work. He ignored the other side of Greek life—the tragic suffering, the priapism, the orgiastic festivals of the wine god, everything Nietzsche was to call “Dionysian”—and this is surely because the stoicism that Winckelmann admired in the Greeks had qualities of Puritanism about it. Greek art, for Winckelmann, was the very opposite of baroque exuberance, of the “hedonism and licentiousness” of the rococo, which he and the emerging German middle classes associated with aristocratic decadence and the courtly French culture whose grip on Friedrich the Great and the ruling classes in Germany they resented. Winckelmann set an example to an entire generation of poets and thinkers of the golden age and helped them to accomplish something in the shadow of their King: the remaking of German culture and cultural institutions. The fact that Greece, a “powerless and almost extinct nation,” should have such an influential "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("cultural")]), _vm._v(" legacy appealed to the German "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bildungsbürger")]), _vm._v(". It had parallels with their own predicament."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n239",
      "id": "n239",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page124"
    }
  }), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page124"
    }
  }, [_vm._v("“The ‘Greek Revival,’ which Winckelmann initiated,” says Henry Hatfield, “profoundly altered the course of German literature: many of its greatest writers from Lessing to our own times would have written differently without his precept and example.” It is not too much to say that it affected the entire history of Western taste, as far afield as Thomas Jefferson. Not only is Winckelmann looked upon now as the founder of classical archaeology; he may be said to be one of the fathers of historicism; he had a formative influence on Herder and through him on the writing of history. Philhellenism took over as one of the defining characteristics of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bildungsbürgertum")]), _vm._v(", the educated middle class, influencing not only the universities but even the state bureaucracy. To Hegel, “…Winckelmann is to be seen as one of those who managed to open up a new organ and a whole new way of looking at things for the human spirit.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n240",
      "id": "n240",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")]), _vm._v(" “By 1871,” said someone else, “Graecophilia had become part of the national patrimony.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n241",
      "id": "n241",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" To Goethe, Winckelmann was like Columbus.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Winckelmann’s brutal murder by stabbing in Trieste (one of the origins of Thomas Mann’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Der Tod in Venedig")]), _vm._v(" ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Death in Venice")]), _vm._v("]) shocked the educated elite across Europe, adding a final dark twist to a remarkable career."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n242",
      "id": "n242",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])])]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadA",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("“T"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("HE")]), _vm._v(" T"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("YRANNY OF")]), _vm._v(" G"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("REECE OVER")]), _vm._v(" G"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ERMANY”")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Winckelmann’s reputation has lasted. He was criticized most notably during a competition organized in 1777 by the Academy of Antiquities in Kassel, which specifically examined Winckelmann’s contribution to antiquarian studies, and in which Christian Gottlob Heyne argued forcefully that Winckelmann’s claim that ancient art declined following its classical phase of the fifth and fourth centuries "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("B.C.")]), _vm._v(" was not supported by the available evidence. But, such criticisms notwithstanding, to underline how enduring his ideas proved to be we may say first that, in 1935, in the shadow of World War II, E. M. Butler published "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Tyranny of Greece over Germany")]), _vm._v(", an examination of the influence of Winckelmann—and Greece—on Lessing, Goethe, Schiller, Hölderlin, Karl Friedrich Schinkel, Carl Gotthard Langhans, Heinrich Schliemann, Friedrich Nietzsche, and Stefan George."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n243",
      "id": "n243",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" “If I were constrained to write a history of German literature from 1700 onwards, I could only do so from this angle; for it "), _c('a', {
    attrs: {
      "id": "page125"
    }
  }, [_vm._v("seems to me that Winckelmann’s Greece was the essential factor in the development of German poetry throughout the latter half of the eighteenth century and the whole of the nineteenth century…Greece has profoundly modified the whole trend of modern civilisation, imposing her thought, her standards, her literary forms, her imagery, her visions and dreams wherever she is known. But Germany is the supreme example of her triumphant spiritual tyranny. The Germans have imitated the Greeks more slavishly: they have been obsessed by them more utterly…” Butler did not think this obsession was entirely healthy. “Only among a people at heart tragically dissatisfied with themselves could this grim struggle with a foreign ideal have continued for so long.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n244",
      "id": "n244",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")]), _vm._v(" Henry Hatfield did not agree. In "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Aesthetic Paganism in German Literature")]), _vm._v(" (1964), he concluded that, from "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Faust")]), _vm._v(" to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Magic Mountain")]), _vm._v(", “From Winckelmann to Rilke, from Goethe to George, the majority of the greatest German writers have been ‘Hellenists’ to some significant degree.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n245",
      "id": "n245",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])])]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadA",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("HE")]), _vm._v(" R"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ETURN OF THE")]), _vm._v(" “M"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ANY")]), _vm._v("-S"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("IDED")]), _vm._v("” M"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("EN")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Winckelmann may have been the German equivalent of Petrarch, but it was Gotthold Ephraim Lessing (1729–81) who was the Marsilio Ficino of the north, the Renaissance figure who wrote on everything from philosophy to Christianity to astronomy to magic to mathematics. Generally regarded as the founder of modern German literature, Lessing too was a scholar, an antiquarian, a philosopher, a philologist, even a theologian, the first of the “many-sided men” who would characterize the third renaissance in Germany. Above all, Lessing was a symbol of the new, of the new world that existed in Germany—and to an extent throughout Europe—in the eighteenth century, which we have been exploring. This was nowhere more evident than in the fact that Lessing became the first famous German writer to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("live")]), _vm._v(" by his pen.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Born in 1729 in Kamenz, northeast of Dresden, he was the son of a pastor and one of twelve children, five of whom died in childhood (not an unusual casualty rate in those days)."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n246",
      "id": "n246",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" Lessing had a precocious passion for books and, at the age of six, it is said, refused to be painted with a birdcage in his hand, demanding instead a stack of books. He attended the University of Leipzig in 1746. Then known as “Little Paris,” Leipzig "), _c('a', {
    attrs: {
      "id": "page126"
    }
  }, [_vm._v("was the center of fashion and publishing, and where Johann Gottsched promoted his literary reforms in the Deutsche Gesellschaft."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n247",
      "id": "n247",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("For the reasons we have been considering, the first generation of creative German writers with a voice of their own emerged around 1750. The most celebrated of these figures, who was slightly ahead of Lessing, was Friedrich Gottlieb Klopstock (1724–1803), who published the first three cantos of his religious epic, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Der Messias")]), _vm._v(" ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Messiah")]), _vm._v("), in 1748."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n248",
      "id": "n248",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" The publication of these cantos “of astonishingly sustained power, discipline and abundant imagery,” had a profound effect upon German readers. To be understood sympathetically today, they must be read against mid-eighteenth-century theories of genius—that the products of genius are glimpses of the divine."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n249",
      "id": "n249",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v(" Classical in form, the cantos switch from religion to science to abstract philosophical subjects, interspersed with vivid real episodes, all sustained by brilliant language, the aim—one aim—being to show that the poet can foment as much enthusiasm and faith as the Messiah.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Klopstock was a many-sided man, too. In his treatise "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Die deutsche Gelehrtenrepublik")]), _vm._v(" (The German Republic of Scholars; 1774), which impressed young writers like Goethe, he broadcast his vision of a “republic of learning,” which found expression, among other places, in his metaphor of the “"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hain")]), _vm._v("” or “grove,” the German equivalent of the Greek "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Helicon")]), _vm._v("."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n250",
      "id": "n250",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])]), _vm._v(" This idea prompted a number of young writers at the University of Göttingen to form a circle called the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hainbund")]), _vm._v(", where the natural and social sciences, literature, and the arts were discussed in equal measure.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Though Lessing was interested in—and to an extent stimulated by—Gottsched and Klopstock, it was a less well-known figure, Christlob Mylius (1722–54), a cousin of Lessing’s, who introduced him to the theater. Lessing wrote a number of early plays though they were overshadowed, to begin with, by his hack (but often brilliant) journalism and the ambitious quarterly he inaugurated that dealt with the drama, as a result of which Lessing was offered a position as reviewer for the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Berlinische privilegierte Zeitung")]), _vm._v(" (which later became the well-known "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Vossische Zeitung")]), _vm._v(")."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n251",
      "id": "n251",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])]), _vm._v(" He now had a regular income and abandoned playwriting to concentrate on criticism. In doing so, he formed a firm friendship with two other many-sided men, Friedrich Nicolai (bookseller, editor, publisher, writer, philosopher, satirist) and Moses Mendelssohn (philosopher, mathematician, critic—a "), _c('a', {
    attrs: {
      "id": "page127"
    }
  }, [_vm._v("man who even risked criticizing the poetry of Friedrich the Great), and all three began to be talked about in Berlin.")])]), _c('a', {
    attrs: {
      "id": "page127"
    }
  }), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page127"
    }
  }, [_vm._v("Over the years, Lessing started, or had a hand in, no fewer than five periodicals, designed to raise the standard of German literature and rescue it from mediocrity."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n252",
      "id": "n252",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")]), _vm._v(" He studied Winckelmann (disagreeing with many of his conclusions about Greek art), dipped into archaeology, and investigated what to him were the crucial differences between art and poetry."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n253",
      "id": "n253",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _vm._v(" In 1765, he was offered the chance to become a dramatist and consultant to a new theater company in Hamburg. This was nothing less than an attempt to create a national theater in Germany. It opened in April 1767, at which time Lessing published the first issue of his fourth periodical, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Die Hamburgische Dramaturgie")]), _vm._v(" ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Hamburg Dramaturgy")]), _vm._v("), the aim of which was to stimulate general interest in the theater. Lessing’s best-known advocacy in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dramaturgy")]), _vm._v(" was that stories about those whose circumstances are nearest to our own move us most and that the presence of kings and princes on stage, though adding grandeur, removes an element of familiarity, making identification with the characters more difficult and therefore less affecting."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n254",
      "id": "n254",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Neither the theater at Hamburg nor the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dramaturgy")]), _vm._v(" was as successful as Lessing hoped. This setback was compounded when, on a trip to Italy to survey its antiquities, he met and married Eva König. In January 1778 she gave birth to a child who died within twenty-four hours, the mother herself dying five days later."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n255",
      "id": "n255",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _vm._v(" In the midst of his despair, Lessing found himself locked into one of the great fights of his life. The previous year, he had begun to publish in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Zur Geschichte und Literatur")]), _vm._v(" ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("To History and Literature")]), _vm._v("), his fifth periodical, excerpts from the manuscripts of Hermann Reimarus’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Apologie oder Schutzschrift für die vernünftigen Verehrer Gottes")]), _vm._v(" ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Apologia for the Reasonable Worshippers of God")]), _vm._v("). Reimarus (1694–1768) was a respected Hamburg schoolteacher who, in his manuscript, argued that Jesus was “a noble-minded but imprudent agitator,” that the Resurrection was an invention of the disciples, and that, therefore, at root, Christianity is based on deceit. The problem with the manuscript was that although Lessing wanted to see it published, Reimarus only ever intended publication in a later, more tolerant time. The two men realized there would be reprisals if the book were published openly and so it was released in installments, anonymously."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n256",
      "id": "n256",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])]), _vm._v(" And indeed, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Apologia")]), _vm._v(" brought about a "), _c('a', {
    attrs: {
      "id": "page128"
    }
  }, [_vm._v("storm of protest from orthodox Protestants. Lessing’s opponents, realizing they could not defeat him intellectually, importuned the Duke of Brunswick, where Lessing was living, to censor him. Financially dependent on the duke, Lessing was forced to comply.")])]), _c('a', {
    attrs: {
      "id": "page128"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("It was a blow, but during the fight Lessing exchanged letters with Reimarus’s daughter and, in so doing, conceived a notion for reviving an earlier exercise. So came about "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nathan der Weise")]), _vm._v(" ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nathan the Wise")]), _vm._v("), his masterpiece, published in 1779.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page128"
    }
  }, [_vm._v("Lessing’s “masterpiece among his masterpieces” was written in blank verse almost a decade before Goethe and Schiller."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n257",
      "id": "n257",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")]), _vm._v(" The plot was taken from a Boccaccio fable in which a father possessed a ring “which had the power of making the wearer, who believed in it, agreeable to God and men.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n258",
      "id": "n258",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])]), _vm._v(" This father loved his three sons equally and so, unwilling to favor one above the others, commissioned two replica rings and bestowed one on each son. After his death, the sons were unable to agree on who had the genuine ring and took their dispute to a judge. This wise man’s verdict was that none of the rings was genuine.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Nathan the Wise")]), _vm._v(" is set in Palestine during the Crusades and, to begin with, it is a play about a man, a Christian Templar, and a woman, the adopted daughter of a Jew, who fall in love not knowing that they are brother and sister."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n259",
      "id": "n259",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _vm._v(" The blood link is revealed soon enough to prevent them from marrying, but, at the same time, they discover that their father was Saladin’s brother. Saladin the Muslim is in effect one of the three sons in the Boccaccio fable. With him, the other main protagonists are Nathan, the Jew, and the Christian Templar. Saladin asks Nathan which of the three great religions is the true one, and Nathan replies with the tale of the three rings. Throughout the twists of the plot, Nathan is portrayed as a wise soul—tolerant and understanding. Saladin, proud and noble himself, recognizes Nathan’s qualities. It is the Christians who, to begin with, are contemptuous and intolerant, in particular toward the Jews. The changing fortunes of the characters eventually soften the Templar’s intolerance, though the Christian Patriarch doesn’t change. And this is the point of the play: Lessing shows us that there are three kinds of individual, morally speaking: those incapable of moral judgments; those who can see the right course of action, yet do nothing; and those who see what is right "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("and")]), _vm._v(" act accordingly. The middle group suffers Lessing’s unmitigated scorn."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n260",
      "id": "n260",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page129"
    }
  }), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page129"
    }
  }, [_vm._v("Lessing is now recognized as the dominant figure in German literary life before Goethe. His plays helped bring to an end the chronic provincialism of German literature and his criticism ended the hold that French literary models had over Germany, in particular what he called in one of his letters Gottsched’s “slavish adherence” to Jean Racine, Pierre Corneille, and Voltaire. Lessing realized that Shakespeare was a much better model; he argued that "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Othello")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("King Lear")]), _vm._v(", and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hamlet")]), _vm._v(" were the first modern dramas to achieve the same emotional impact of Sophocles. He argued that Dr. Faust, known to German audiences since the Middle Ages through a puppet play, would lend itself to the Shakespearean approach. This “provided a foundation on which the Weimar classicism of Goethe and Schiller was to build in the closing decade of the century” (Goethe’s original version of the drama—the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Urfaust")]), _vm._v(", written in 1772–75, wasn’t discovered until late in the nineteenth century, and was never performed. But "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Faust, Der Tragödie erster Teil")]), _vm._v(" is widely viewed now as the decisive moment of innovative change on the German stage)."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n261",
      "id": "n261",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Not least, Lessing’s meticulous investigation of the Gospels was the first dispassionate scientific examination of their origins, boosting scholarship. In the words of one critic, he was “the most admirable figure in the history of German thought and literature between Luther and Nietzsche.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n262",
      "id": "n262",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])])]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadA",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("HE")]), _vm._v(" O"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("RIGINS OF")]), _vm._v(" M"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ODERN")]), _vm._v(" S"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("CHOLARSHIP")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("We now need to examine two others who were to convert Winckelmann’s theories into definite institutional innovation.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("The development of classical studies as we understand them today owes much to the work and “uncompromising vision” of Friedrich August Wolf (1759–1824). Nineteenth-century classical scholarship—the “conquest of the ancient world by scholarship,” as Ulrich von Wilamowitz-Moellendorff, the eminent nineteenth-century philologist put it—properly commences with Wolf. Wolf from the beginning rejected any prospect of theological training and was determined to rid classical studies of any clerical control. He was not the first modern philologist, but his rigorous methods of source criticism shaped and promoted philology as the new queen of disciplines. His 1795 study of Homer has been described by An"), _c('a', {
    attrs: {
      "id": "page130"
    }
  }, [_vm._v("thony Grafton as “the charter of classical scholarship as an independent discipline.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n263",
      "id": "n263",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Born in 1759, the son of a schoolteacher, Wolf could read some Greek at the age of six, and rather more Latin and French. At Göttingen, although he kept his distance from the most famous classicist there, Christian Gottlob Heyne (1729–1812), he nonetheless emulated the older man’s dedication: like Heyne, he slept for just two nights a week for six months, so as to immerse himself in his beloved classical authors as quickly as possible, keeping himself awake by sitting with his feet in a bowl of cold water. He would bind up one eye with a bandage to rest it, while he used the other. His dedication was reminiscent of Winckelmann and the block of wood he attached to his foot.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Wolf’s devotion paid off. In 1783, at the age of twenty-four, he was offered the position of professor of pedagogy and philosophy at the University of Halle."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n264",
      "id": "n264",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])]), _vm._v(" At Halle, the original home of the seminar, he introduced his own, aimed at turning out specialist classical scholars. He succeeded so well that his seminar became the model for the new German universities of the nineteenth century. Wolf, says Suzanne Marchand, was haughtily convinced of the power of philological study “to instil self-discipline, idealism, and nobility of character,” a conviction that spread throughout the civil service and professions as the nineteenth century wore on.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("His best-known works, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Prolegomena ad Homerum")]), _vm._v(" ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Prolegomena to Homer")]), _vm._v("; 1795), and the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Darstellung der Altertumswissenschaft")]), _vm._v(" ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Classical Scholarship: A Summary")]), _vm._v("; 1807), were not especially original but his painstaking textual interpretations, combined with some sharp common-sense thinking on Homer and his times, placed philological expertise above the philosophical. “[Wolf] was the first to show that access to the Greek mind was to proceed by means of strict attention to linguistic, grammatical and orthographical detail.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n265",
      "id": "n265",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("In order to support his argument that Homer’s poems were written down only in the mid-sixth century "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("B.C.,")]), _vm._v(" when Pisistratus was tyrant of Athens, Wolf used the fact that linguistics varied in the past to show how, in the earliest manuscripts, entire sections had been interpolated; and, by studying what was missing (“the argument from silence”), he deduced further conclusions—for example, classical commentators found no mention of writing in the Homeric poems. In the process, Wolf was open "), _c('a', {
    attrs: {
      "id": "page131"
    }
  }, [_vm._v("about his methods, admitting the difference between what he knew and what he merely conjectured, identifying which authorities he trusted and which he did not."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n266",
      "id": "n266",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("In the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Darstellung")]), _vm._v(", he distinguished between Greeks and Romans on the one hand, and Egyptians, Israelites, and Persians on the other. He said unequivocally that only the Greeks and Romans possessed “a higher "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Geistescultur")]), _vm._v(" (intellectual culture).” The “Orientals,” as he described the rest, had merely reached the level of “"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("bürgerliche Policirung oder Civilisation")]), _vm._v(" [policed civility or civilisation].” He thought cultures need “security, order and leisure” so as to evolve “noble perceptions and knowledge” and this had not happened in antiquity outside Greece and Rome. Literature in particular was vital for a culture—it was the free, untrammeled product of a nation. For Wolf, therefore, Greek and Roman civilization alone constituted "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Altertum")]), _vm._v(" (antiquity). Egyptians, Israelites and the rest were “Barbari.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n267",
      "id": "n267",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])]), _vm._v(" In his full-fledged scheme, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Altertumswissenschaft")]), _vm._v(", for Wolf, comprised no fewer than twenty-four disciplines—from grammar to epigraphy to numismatics to geography, all being needed for full access to a text.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("As a scholar, Wolf’s reputation was supreme. Goethe attended his lectures, and in 1796 Wolf was offered the chair at the University of Leiden in the Netherlands, then the summit in classics. He turned it down and for the next decade continued at Halle until the French occupation of the city in 1806 changed everything. It might have been a disaster, but only three years later he was offered and accepted the first professorship of Altertumswissenschaft at the new University of Berlin.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Suzanne Marchand argues that Wolf’s pursuit of philological expertise “contributed to the turning inward of the university community after 1800.” This was an important innovation in scholarship. “Wolfian haughty insistence on ‘disinterestedness’ and scholarly autonomy imbued philology and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Altertumswissenschaft")]), _vm._v(" with a kind of social detachment rare among eighteenth-century scholars, many of whom had depended on the patronage of aristocrats or income from a second job outside the university. Eighteenth-century professors, too, had generally been esteemed for their lecture skills rather than for their independent research.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Winckelmann had made more of the comparison between the Greeks and the moderns than between the Greeks and the Germans. The advent "), _c('a', {
    attrs: {
      "id": "page132"
    }
  }, [_vm._v("of the wars with France changed all that too. Amid comprehensive defeat, the parallels between the German predicament and that of ancient Athens—politically fragmented, conquered by force of arms, yet having a superior culture (to Rome) united by a single language—became more plausible. “In the shadow of Prussia’s defeat in the Battle of Jena in 1806, German philhellenism underwent a profound change; its anti-aristocratic aspects were transformed into pronational sentiments, and a new form of pedagogy, built on the notion of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bildung")]), _vm._v(", made its peace with the state and the status quo.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n268",
      "id": "n268",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")]), _vm._v(" Instead of birth or position, neohumanism—the foundational belief of the new Bildungsbürgertum—judged an individual according to his or her cultural capabilities.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("One of Wolf’s close friends was Wilhelm von Humboldt. Humboldt shared with Wolf a belief in the study of the ancients. For him, the study of classical texts provided a means of meeting the more impressive self-educated individuals who had existed in the past and it was also, he felt, a way to “discipline the mind.” Both Wolf and Schiller, to whom Humboldt was also close, convinced him of the suitability of ancient Greece as a countervailing influence to the social fragmentation of the late eighteenth and early nineteenth centuries. In 1802, Humboldt was appointed Prussian ambassador to the Holy See, providing him with ample opportunity to live among the antiquities of Rome. This became practically relevant in 1808, when a number of Prussian schemes for reform were initiated, stimulated by Napoleon’s comprehensive defeat of the Prussians at the Battle of Jena. These reforms, carried through between 1806 and 1812, were implemented under the aegis of two energetic nobles, Karl August von Hardenberg (1750–1822) and Karl vom Stein zum Altenstein (1770–1840). The most important of the reform measures were the freeing of serfs, the granting of a (limited) form of citizenship to Jews, certain economic reforms, and a rethinking of the bureaucracy—which is where Humboldt came in. A new department of the Interior Ministry—for educational and ecclesiastical affairs—was created, and Humboldt, a friend of Hardenberg and Altenstein, was made minister in charge. Until then, educational institutions in Germany (in particular primary and secondary schools) had been administered by the church, but Hardenberg and Altenstein were convinced a new relationship between the state and the schools was needed."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n269",
      "id": "n269",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])]), _vm._v(" Humboldt’s responsibilities included the supervision "), _c('a', {
    attrs: {
      "id": "page133"
    }
  }, [_vm._v("of schools, universities, the art and science academies, cultural associations, and the Royal Theater, all close to his heart. He now became patron and guardian of the educational ideal that had shaped himself.")])]), _c('a', {
    attrs: {
      "id": "page133"
    }
  }), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page133"
    }
  }, [_vm._v("As a fundamental measure, he centralized funding. He introduced a requirement that all prospective university students pass a new examination, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Abitur")]), _vm._v(", the main element of which was testing translations of Greek and Latin texts. Furthermore, he made the Abitur the sole prerogative of a particular type of classical school—known as the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gymnasium")]), _vm._v(". Only these could prepare pupils for university, a state of affairs that continued for close to a hundred years. The culmination of Humboldt’s reforms was his design of the University of Berlin, founded in 1810. Consolidating the trend begun at Göttingen under Münchhausen, Humboldt promoted Berlin’s philosophical faculty (containing philology, philosophy proper, and the natural sciences) over and above the more “practical” faculties of medicine, law, and theology. More than that, within the philosophical faculty he subordinated the natural sciences to the humanities, “fearing that the former would otherwise slide into mindless empiricism.” By offering large salaries (again taking a leaf out of Münchhausen’s book) Humboldt soon lured to Berlin a raft of brilliant young scholars across many disciplines. “Berlin quickly became known as an "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Arbeitsuniversität")]), _vm._v(", an institution for industrious, mature and unsocial scholars such as Wolf and Humboldt themselves had been.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n270",
      "id": "n270",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Humboldt wasn’t at the ministry for long—he left in June 1810. By then, however, through the university in Berlin, the Abitur, and the Gymnasium, he had made neohumanist Bildung “the cultural philosophy of the Prussian state.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Humboldt had a clear understanding of what, exactly, Bildung was. For him, the development of social morality within an individual was an all-important progression which depended on that individual’s “selftransformative progress” from a natural state of ignorance and immaturity to “self-willed citizenship”: a shared understanding of civic harmony and loyalty to the state, a belief that spiritual emancipation through education in the humanities was the true path to (inner) freedom and “willing citizenship.” It was a vision both egalitarian and elitist at the same time and this paradox was to have far-reaching consequences."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n271",
      "id": "n271",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Partly under Wolf’s influence, and partly under Herder’s, Humboldt "), _c('a', {
    attrs: {
      "id": "page134"
    }
  }, [_vm._v("specified that language was to be the main focus of education. He insisted that the very shape and structure of a language revealed a nation’s character. Bildung, for Humboldt, could therefore be achieved only by study of the Greeks, allied to an understanding of language. For Humboldt, Bildung—true (inner) freedom—involved three things: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Zwecklosigkeit")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Innerlichkeit")]), _vm._v(", and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wissenschaftlichkeit")]), _vm._v(" (non-purposiveness—in the sense of non-utilitarian—inwardness, and scholarliness). All (male) students at the Gymnasium must attempt this historico-philological form of learning."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n272",
      "id": "n272",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("He both did and did not succeed. By the time of his death in 1824, Wolf’s vision had prevailed: classical philology was the recognized foundation for professionalized humanistic scholarship."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n273",
      "id": "n273",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])]), _vm._v(" Later on in the nineteenth century, when German scholarship became the envy of the world, many disciplines would seem to have little to do with ancient Greece. But the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("methodology")]), _vm._v(" on which their successes were based went back to Humboldt, Wolf, and—ultimately—Winckelmann.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cbcd86d0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062018465_Chapter_3.vue
// module id = 84
// module chunks = 0